let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4WDAC")).then(() => parcelRequire('aDy4u'));